/**
 * What the purchase UI may offer, read only from `GET /api/book` (ebook-plan § 3.6, § 3.14).
 * The server decides `purchase.available` (purchase mode, the staff-only and test-key guards,
 * price, seller, not owned, nothing to claim); the UI never offers a purchase it did not allow.
 */
import { ROUTES } from '@/config/routes';
import { formatPrice } from '@/utils/locale';
import { legalUrl } from '@/utils/legal';
import type { BookSeller, BookVisibleState } from '@/services/api/bookContract';
import type { Language } from '@/types';

export interface PurchaseOffer {
  price: string;
  consentVersion: string;
  seller: BookSeller;
}

/** The offer when this account may buy now; null otherwise (owner, staff-only for others, …). */
export function purchaseOffer(state: BookVisibleState): PurchaseOffer | null {
  const { purchase } = state;
  if (state.owned || !purchase.available || !purchase.consentVersion || !purchase.seller) return null;
  return { price: formatPrice(purchase.priceCents / 100), consentVersion: purchase.consentVersion, seller: purchase.seller };
}

/** `/book` with the purchase sheet open (the preview-end card and the /success card link here). */
export const BOOK_BUY_PATH = `${ROUTES.book}?buy=1`;

/** The e-book section of the Terms on lukaaji.com. */
export function bookTermsUrl(language: Language): string {
  return `${legalUrl('terms', language)}#ebook`;
}
